import { EntityStatusDesc } from '../../../models/entity.model'
import { TaskStatus, TaskType } from '../models/task.types'

export const TASK_FRAGMENT = 'tag'

export const TASK_TYPES: EntityStatusDesc<TaskType>[] = [
  {
    code: 'ACTIVITY_EXECUTION',
    name: 'Activity execution',
  },
  {
    code: 'CONTEXT_EXECUTION',
    name: 'Raw execution',
  },
  {
    code: 'ORDERS_UPDATE',
    name: 'Orders update',
  },
  {
    code: 'PRODUCTS_UPDATE',
    name: 'Products update',
  },
  {
    code: 'WAREHOUSE_UPDATE',
    name: 'Warehouse update',
  },
  {
    code: 'REPLENISHMENTS_IMPORT',
    name: 'Replenishments update',
  },
]

export const TASK_STATUSES: EntityStatusDesc<TaskStatus>[] = [
  {
    code: 'COMPLETED',
    name: 'Completed',
  },
  {
    code: 'FAILED',
    name: 'Failed',
  },
  {
    code: 'PENDING',
    name: 'Pending',
  },
  {
    code: 'RUNNING',
    name: 'Running',
  },
]
